import React, { useEffect } from "react";
import { mergeStyleSets } from "@fluentui/react";
import { DocumentPartTreeSelection, TreeViewDataItem } from "./DocumentPartTree";
import { DocumentOutline } from "../document/DocumentOutline";
import { FlatPathTreeItem } from "../generic/FlatPathTreeExplorer";
import { fetchDocumentPartDetails } from "../../api/document/DocumentsPart";

export interface DocumentSourcesProps {
  onItemSingleClick: (item: DocumentPartTreeSelection) => void;
  data: TreeViewDataItem[];
  idPartRoot: string;
}

export const DocumentSources: React.FunctionComponent<DocumentSourcesProps> = (props) => {
  const [documentPart, setDocumentPart] = React.useState<FlatPathTreeItem>(null);
  useEffect(() => {
    fetchDocumentPartDetails(props.idPartRoot).then((obj) =>
      setDocumentPart({ text: obj.name, key: obj.id, document: obj, readPermission: true })
    );
  }, [props.idPartRoot]);

  const classNames = mergeStyleSets({
    pageContainer: {
      position: "relative",
      paddingBottom: "80px",
    },

    contentWrap: {
      overflow: "auto",
    },
    content: {
      position: "relative",
    },
  });

  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ zIndex: "1" }}>
            {documentPart && (
              <div className={classNames.pageContainer}>
                <div className={classNames.contentWrap}>
                  <div className={classNames.content}>
                    <DocumentOutline
                      onItemClick={props.onItemSingleClick}
                      isSourcesRibbon={true}
                      selectedTreeItem={documentPart}
                      idPartRoot={props.idPartRoot}
                      ignoreFetchPath={true}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
